import { render } from "./CardBrandLogos.vue?vue&type=template&id=e3ade5e8&scoped=true"
import script from "./CardBrandLogos.vue?vue&type=script&lang=js"
export * from "./CardBrandLogos.vue?vue&type=script&lang=js"

import "./CardBrandLogos.vue?vue&type=style&index=0&id=e3ade5e8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3ade5e8"]])

export default __exports__